module.exports = __webpack_public_path__ + "img/第一生命香港有限公司.fde84d8d.png";